import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Layout from '@/components/feature/Layout';
import Home from '@/pages/home/page';
import CategoryPage from '@/pages/category/page';
import ComicDetail from '@/pages/comic-detail/page';
import AboutPage from '@/pages/about/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'category/:slug',
        element: <CategoryPage />,
      },
      {
        path: 'comic/:id',
        element: <ComicDetail />,
      },
      {
        path: 'about',
        element: <AboutPage />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

export default routes;